<div class="container">
  <p>{{ 'MAP_FILTER.SAVE_INFO' | translate }}</p>
  <mtn-text-field [form]="form" controlName="name" [placeholder]="'MAP_FILTER.NAME' | translate" [isRequired]="true"></mtn-text-field>
  <mtn-text-area-field [form]="form" controlName="description" [placeholder]="'MAP_FILTER.DESCRIPTION' | translate"
                       [maxLength]="50"></mtn-text-area-field>
</div>
